import { useEffect } from 'react'; // 引入 useEffect
import { Link } from 'react-router-dom';
import { ShieldCheck, Lock, Eye, Database, Share2, Cookie, Mail, ArrowLeft } from 'lucide-react';
import Header from '@/components/Header';
// 定义隐私政策的数据结构
const privacyPolicyData = {
  title: "孔明智算互联网平台隐私协议",
  effectiveDate: "2026年5月22日",
  company: "成都孔明智算互联网科技有限公司",
  websiteName: "孔明智算互联网平台",
  operator: "孔明智算互联网科技有限公司",
  address: "四川省成都市武侯区金花街道九架车巷55号悦湖数园1栋303室",
  email: "zzzc999@126.com",
  allContent:"隐私协议（以下简称“本协议”）旨在向您说明本网站如何收集、存储、使用、共享、保护您的个人信息，以及您享有的相关权利。您访问、浏览、注册、使用本网站全部或部分服务，即表示您已充分阅读、理解并自愿接受本协议全部条款。若您不认可本协议任意条款，请立即停止使用本网站服务。本协议依据《中华人民共和国个人信息保护法》《中华人民共和国网络安全法》《中华人民共和国电子商务法》等相关法律法规制定，为本网站用户隐私保护的核心合规文件。",
  allContent1:"本政策依据《中华人民共和国个人信息保护法》《中华人民共和国网络安全法》《中华人民共和国电子商务法》等相关法律法规制定，为本网站用户隐私保护的核心合规文件。",
  sections: [
    {
      title: "一、适用范围",
      content: [
        "本政策依据《中华人民共和国个人信息保护法》《中华人民共和国网络安全法》《中华人民共和国电子商务法》等相关法律法规制定，为本网站用户隐私保护的核心合规文件。",
        "2. 本政策仅适用于本网站自主运营的服务，不适用于第三方网站、第三方平台、第三方服务提供者提供的服务，第三方服务的隐私规则由其自身负责。"
      ]
    },
    {
      title: "二、我方收集的个人信息",
      content: [
        "我方秉持合法、正当、必要、诚信原则，仅收集提供服务所必需的个人信息，不会收集与服务无关的信息，具体收集类型如下：",
        "（一）您主动提供的信息",
        "1. 注册/登录信息：您注册账号、绑定身份时提交的手机号、邮箱、用户名、登录密码、头像等信息。",
        "2. 业务交互信息：您通过网站留言、咨询、反馈、提交表单、申请服务时主动填写的姓名、联系方式、单位信息、需求描述等内容。",
        "3. 交易服务信息：若网站提供交易、付费服务，我方会收集订单信息、支付凭证、收货/寄件信息等服务必要信息。",
        "（二）被动自动收集的信息",
        "您访问本网站时，我方会通过Cookie、日志、服务器记录等方式自动收集基础设备及访问信息，用于保障网站正常运行、优化服务体验，包括：IP地址、设备型号、浏览器类型、访问时间、浏览页面、点击记录、页面停留时长、网络状态等。",
        "所有自动收集信息均采取匿名化、碎片化处理，不会单独用于定位特定自然人身份。",
        "（三）不收集敏感个人信息",
        "除非您主动自愿单独授权，我方不会收集您的身份证号、生物识别信息、银行卡信息、行踪轨迹、健康信息等敏感个人信息。若因特殊服务需要收集敏感信息，我方将提前告知用途、范围、留存期限，并取得您明示同意。"
      ]
    },
    {
      title: "三、信息使用规则",
      content: [
        "我方收集的个人信息仅用于以下合法、必要用途，不会超出授权范围使用：",
        "1. 提供、维护、优化本网站各项服务，保障网站正常访问、功能正常运行；",
        "2. 完成用户身份核验、账号管理、服务对接、问题回复、售后处理；",
        "3. 统计网站访问数据、分析用户使用习惯，优化网站内容、功能及服务体验；",
        "4. 推送必要的服务通知、系统公告、功能更新提醒（用户可自主关闭非必要推送）；",
        "5. 防范账号风险、排查安全漏洞、抵御恶意攻击，保障网站及用户信息安全；",
        "6. 履行法律法规、司法机关、监管部门的法定要求。",
        "特别约定：我方不会将您的个人信息用于未授权的营销推广、商业倒卖等行为，未经您单独明示同意，不会变更信息使用用途。"
      ]
    },
    {
      title: "四、信息存储与保护",
      content: [
        "（一）存储期限",
        "我方仅在服务存续期间及法律法规要求的留存期限内保存您的个人信息：服务所需信息在您持续使用服务期间留存；注销账号、终止服务后，我方将对个人信息进行删除或匿名化处理，原则上在15个工作日内完成。但若相关法律法规对交易记录等信息有最低留存期限要求，我方将在该等法定期限内继续以不可识别特定个人的方式留存和使用，期满后立即彻底删除或匿名化。",
        "（二）安全保护措施",
        "我方采用行业标准的安全技术和管理制度保护用户个人信息，包括数据加密存储、访问权限管控、安全日志审计、定期安全检测、服务器防护等措施，防范信息泄露、丢失、篡改、滥用、非法访问等风险。",
        "我方对内部员工、合作服务商建立严格的数据保密制度，仅授权必要人员接触用户信息，严禁私自查阅、复制、泄露、售卖用户数据。",
        "若发生用户信息安全事件，我方将第一时间启动应急预案，及时排查处置，并按照法律法规要求向监管部门报备、告知用户。",
      ]
    },
    {
      title: "五、个人信息共享、转让与公开披露",
      content: [
        "我方不会随意共享、转让、公开您的个人信息，仅在以下情形中处理：",
        "1. 经您单独明示同意，您主动授权我方向特定第三方提供信息；",
        "2. 为完成服务必需，委托合规第三方服务商提供技术支持、服务托管、数据运维等服务，且已与第三方签订严格保密协议，要求其严格遵守隐私保护规则，不得滥用、泄露用户信息；",
        "3. 依据法律法规、司法判决、行政机关合法要求，必须披露的情形；",
        "4. 涉及公共利益、紧急情况，为保护用户或公众人身财产安全的必要情形。",
        "任何超出上述范围的信息共享、转让、公开行为，我们将提前告知用户并取得授权。"
      ]
    },
    {
      title: "六、Cookie及同类技术使用说明",
      content: [
        "本网站使用Cookie、Web Beacon等同类技术，用于记录用户访问偏好、保持登录状态、优化网站服务、统计访问数据，提升用户浏览体验。",
        "您可通过浏览器设置自主拒绝、清除Cookie，但关闭Cookie后，可能导致网站部分功能无法正常使用。我们不会通过Cookie收集用户敏感信息，不会用于商业追踪和恶意营销。"
      ]
    },
    {
      title: "七、用户个人权利",
      content: [
        "依据相关法律法规，您对自身个人信息享有以下全部合法权利：",
        "1. 知情权与访问权：您可随时向我们查询、了解我们收集、使用、存储您个人信息的相关情况；",
        "2. 更正权：若您的个人信息存在错误、遗漏，可随时申请更正、补充；",
        "3. 删除权：在信息处理超出必要范围、目的已实现、您撤回同意、协议终止等情形下，您可申请删除个人信息；",
        "4. 撤回同意权：您可随时撤回此前授权的信息处理同意，撤回后我们将停止对应信息处理行为，不影响此前合法的处理行为；",
        "5. 账号注销权：您可随时申请注销网站账号，账号注销后我们将及时清理您的个人信息；",
        "6. 投诉申诉权：若您认为我们的信息处理行为侵犯您合法权益，可通过本协议预留联系方式反馈申诉。"
      ]
    },
    {
      title: "八、未成年人隐私保护",
      content: [
        "本网站面向普通公众提供服务，不专门面向未成年人。若您为未满18周岁的未成年人，请在监护人陪同、同意及指导下使用本网站服务，请勿自行提交个人信息。",
        "若我方不慎收集到未成年人个人信息，经核实后将第一时间主动删除；若监护人发现未成年人未经许可向我方提交信息，可随时联系我方，我方将立即删除相关信息。"
      ]
    },
    {
      title: "九、协议更新与通知",
      content: [
        "我方有权根据法律法规更新、业务调整、服务升级等情况，适时修订本隐私协议。协议修订后，我方将通过网站公告、页面弹窗、站内通知等方式公示，公示后即生效。",
        "您在协议更新后继续使用本网站服务，即视为认可修订后的协议条款。若您不接受更新条款，需立即停止使用本网站服务。"
      ]
    },
    {
      title: "十、免责条款",
      content: [
        "1. 因用户自身泄露账号密码、主动公开个人信息、自行点击第三方链接导致的信息泄露，我们不承担责任；",
        "2. 因网络故障、黑客攻击、病毒入侵等不可抗力或第三方恶意行为导致的信息风险，我方将尽力补救，对不可归责于我方的损失不承担责任；",
        "3. 第三方网站、第三方服务的隐私行为不受本政策约束，您访问第三方服务产生的隐私风险由您和第三方承担，与我方无关。"
      ]
    },
    {
      title: "十一、联系与投诉渠道",
      content: [
        "若您对本隐私协议有疑问、异议，或需要申请信息查询、更正、删除、注销等服务，您可通过以下方式联系我们：",
        "联系邮箱：zzzc999@126.com",
        "我方将在收到您的申请后7个工作日内完成核实并予以回复处理。"
      ]
    },
    {
      title: "十二、附则",
      content: [
        "1. 本政策的订立、生效、解释及争议解决均适用中华人民共和国大陆地区法律。",
        "2. 双方因本政策产生的争议，优先通过友好协商解决；协商不成的，可向成都市武侯区人民法院提起诉讼。",
        "3. 本政策未尽事宜，遵照国家相关法律法规执行。",
        "(本政策最终解释权归本网站运营主体所有)"
      ]
    }
  ]
};

export default function PrivacyPolicy() {
    // 添加 useEffect 钩子，在组件挂载时将窗口滚动到顶部
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="min-h-screen bg-gray-50 pt-24 pb-16">
      {/* 使用 Header 组件 */}
      <Header />

      <div className="section-container max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* 页面标题 */}
        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">{privacyPolicyData.title}</h1>
          <p className="text-gray-500">生效日期：{privacyPolicyData.effectiveDate}</p>
        </div>

        {/* 主要内容区域 */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 md:p-12 space-y-10">
          {/* 公司信息 */}
          <div className="space-y-2 text-sm text-gray-600">
            <p><strong>主体信息：</strong>{privacyPolicyData.company}</p>
            <p><strong>网站名称：</strong>{privacyPolicyData.websiteName}</p>
            <p><strong>运营主体：</strong>{privacyPolicyData.operator}</p>
            <p><strong>联系地址：</strong>{privacyPolicyData.address}</p>
            <p><strong>联系邮箱：</strong>{privacyPolicyData.email}</p>
          </div>

          <div className="space-y-3">
            <p className="text-gray-600 leading-relaxed">{privacyPolicyData.allContent}</p>
          </div>
          <div className="space-y-3">
            <p className="text-gray-600 leading-relaxed">{privacyPolicyData.allContent1}</p>
          </div>

          {/* 各章节内容 */}
          {privacyPolicyData.sections.map((section, index) => (
            <section key={index} className="space-y-4">
              <div className="flex items-center gap-3 mb-4">
                {/* <ShieldCheck className="w-6 h-6 text-[#1c5bff]" /> */}
                <h2 className="text-xl font-bold text-gray-900">{section.title}</h2>
              </div>
              <div className="space-y-3">
                {section.content.map((paragraph, pIndex) => (
                  <p key={pIndex} className="text-gray-600 leading-relaxed">
                    {paragraph}
                  </p>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}